import type { Nullable } from "@iot-platform/core";
import { ToastManagerRepository } from "@iot-platform/core";
import type { User } from "@user/domain/models/user.model";
import type { UserRepository } from "@user/domain/repositories/user.repository";
import { userTypes } from "@user/root/user-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class UserGetByIdUseCase {
    constructor(
        @inject(userTypes.repositories.UserRepository)
        private readonly userRepository: UserRepository,
    ) {}

    async execute(userId: number): Promise<Nullable<User>> {
        const userResult = await this.userRepository.getById(userId);

        if (userResult.isErr()) {
            const error = userResult.error.message;

            ToastManagerRepository.error(error);
        }

        return userResult.match(
            (user) => user,
            () => null,
        );
    }
}
